module.exports = __webpack_public_path__ + "media/images/flags/4x3/fro-7844db71e1f68678e784845cb1b94e20.svg";